import { Button } from '@chakra-ui/react';
import { useExplorerPageStore } from '@store/app.store';
import { useStyledToast } from '@util/hooks';
import { useNavigate } from 'react-router-dom';
import { SFSparkleStarIcon } from '@assets/icons';
import { useStatsigClient } from '@statsig/react-bindings';
/**
 * ExplorerAnalyzeButton component
 * This component renders a button that, when clicked, sets the provided sources in local storage for use on the analyze page.
 * Then, the user is redirected to the analyze page.
 * @param {Array<any>} sourcesToSet
 */

function ExplorerAnalyzeButton({ sourcesToSet, ...props }) {
  const { checkGate } = useStatsigClient();
  const navigate = useNavigate();
  const setSourcesInLocalstorage = useExplorerPageStore((state) => state.setSources);
  const toast = useStyledToast();

  const isExplorerEnabled = checkGate('explorer-access-buttons');
  if (!isExplorerEnabled) return null;

  const onClick = () => {
    if (!sourcesToSet) {
      toast({
        title: 'No Sources Selected',
        status: 'error'
      });
      return;
    }
    const sourcesMapped = sourcesToSet
      ?.filter((s) => s?.id && s?.source_data)
      .map((s) => ({
        id: s.id,
        title: s.source_data.title,
        type: 'Card'
      }));
    if (!sourcesMapped?.length) {
      toast({
        title: 'No Valid Sources Selected',
        status: 'error'
      });
      return;
    }
    setSourcesInLocalstorage(sourcesMapped);
    navigate('/explorer');
  };

  return (
    <Button
      variant='reskinOutline'
      leftIcon={<SFSparkleStarIcon boxSize={4} />}
      size='md'
      onClick={onClick}
      {...props}
    >
      Chat with
    </Button>
  );
}

export default ExplorerAnalyzeButton;
